import React from 'react';

function Footer() {
  return (
    <footer className="bg-light text-center text-muted py-3 mt-auto border-top">
      <div className="container">
        <small>
          &copy; {new Date().getFullYear()} Suyog ERP. All rights reserved.
        </small>
      </div>
    </footer>
  );
}

export default Footer;
